import { axiosClient } from "./axiosClient";

export const listContributions = async (params) => {
  const res = await axiosClient.get("/contributions/", { params });
  return res.data;
};

export const createContribution = async (payload) => {
  const res = await axiosClient.post("/contributions/", payload);
  return res.data;
};

export const updateContribution = async (id, payload) => {
  const res = await axiosClient.patch(`/contributions/${id}/`, payload);
  return res.data;
};

export const deleteContribution = async (id) => {
  const res = await axiosClient.delete(`/contributions/${id}/`);
  return res.data;
};

export const exportContributionsCsvUrl = (params) => {
  const qs = new URLSearchParams(params).toString();
  return `/contributions/export/csv/${qs ? `?${qs}` : ""}`;
};

// ✅ NEW: Contributor Cards Summary
export const getContributorSummary = async (params = {}) => {
  const res = await axiosClient.get("/contributions/contributors/summary/", { params });
  return res.data;
};

// ✅ NEW: Contributor dropdown list
export const getContributorNames = async () => {
  const res = await axiosClient.get("/contributions/contributors/");
  return res.data;
};
